let WidgetType = {
  BBRAZIL: { id: 1, name: 'bbrazil', hasHeader: true, hasLabels: true},
	FIT: { id: 2, name: 'fit', hasHeader: false, hasLabels: false},
  SELETO: { id: 3, name: 'seleto', hasHeader: true, hasLabels: false},
};

export default WidgetType;



// WEBPACK FOOTER //
// ./src/enums/WidgetType.js